/**
 * ブラウザ全体の再読み込み・遷移
 * SPA内遷移では回復できない状態から、最新のindex.htmlを取得し直すために使います。
 */

/**
 * 現在のURLを再読み込みする
 * @returns {void}
 */
export const reloadCurrentPage = (): void => {
  window.location.reload();
};

/**
 * 指定パスへ全画面遷移する
 * @param {string} path - 遷移先パス
 * @returns {void}
 */
export const assignPage = (path: string): void => {
  window.location.assign(path);
};
